import thunk, {ThunkAction as ReduxThunkAction, ThunkDispatch, ThunkMiddleware} from 'redux-thunk';

import {AppAction} from './appActions';
import {AppState} from './appState';

/*
 * Types.
 */

export type AppThunkMiddleware = ThunkMiddleware<AppState, AppAction>;
export type AppThunkDispatch = ThunkDispatch<AppState, void, AppAction>;
export type AppThunkExtension = {
  dispatch: AppThunkDispatch;
};

export interface ThunkAction<R = void> extends ReduxThunkAction<R, AppState, void, AppAction> {}
export interface ThunkAsyncAction<R = void> extends ThunkAction<Promise<R>> {}

/*
 * Middleware.
 */

export const appThunkMiddleware = thunk as AppThunkMiddleware;
